import { memoizeDeep, safeMerge } from "../common/utilities";
const setTheme = memoizeDeep(function (_ref) {
  let {
    section,
    standalone,
    highlighted,
    kind,
    disabled
  } = _ref;
  let cssRoot = {},
      cssHeader = {},
      cssHeaderContent = {},
      cssBody = {},
      cssBodyContent = {},
      cssErrorIcon = {},
      cssToggleButton = {},
      cssHeaderContainer = {};

  if (section) {
    cssRoot = section.root;
    cssHeader = section.header;
    cssHeaderContent = section.headerContent;
    cssHeaderContainer = section.headerContainer;
    cssBody = section.body;
    cssBodyContent = section.bodyContent;
    cssErrorIcon = section.errorIcon;
    cssToggleButton = section.toggleButton;

    if (standalone) {
      cssToggleButton = safeMerge(cssToggleButton, section.modifiers.standalone.toggleButton);
      cssHeaderContent = safeMerge(cssHeaderContent, section.modifiers.standalone.headerContent);
    }

    if (highlighted) {
      cssErrorIcon = safeMerge(cssErrorIcon, section.modifiers.highlighted.errorIcon);
    }

    if (kind === "disclosureList") {
      cssRoot = safeMerge(cssRoot, section.modifiers.disclosureList.root);
      cssBodyContent = safeMerge(cssBodyContent, section.modifiers.disclosureList.bodyContent);
      cssToggleButton = safeMerge(cssToggleButton, section.modifiers.disclosureList.toggleButton);
      cssHeader = safeMerge(cssHeader, section.modifiers.disclosureList.header);
      cssToggleButton = safeMerge(cssToggleButton, section.modifiers.disclosureList.toggleButton);
      cssHeaderContent = safeMerge(cssHeaderContent, section.modifiers.disclosureList.headerContent);
    }

    if (disabled) {
      cssRoot = safeMerge(cssRoot, section.modifiers.disabled.root);
      cssHeader = safeMerge(cssHeader, section.modifiers.disabled.header);
      cssHeaderContainer = safeMerge(cssHeaderContainer, section.modifiers.disabled.headerContainer);
    }
  }

  return {
    cssRoot,
    cssHeader,
    cssHeaderContent,
    cssHeaderContainer,
    cssBody,
    cssBodyContent,
    cssErrorIcon,
    cssToggleButton
  };
});
export default function (_ref2) {
  var _theme$components;

  let {
    theme,
    standalone,
    highlighted,
    kind,
    disabled
  } = _ref2;
  const section = theme === null || theme === void 0 ? void 0 : (_theme$components = theme.components) === null || _theme$components === void 0 ? void 0 : _theme$components.section;
  return setTheme({
    section,
    standalone,
    highlighted,
    kind,
    disabled
  });
}